import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getConfigurableData} from './configurableAPI';

const initialState = {
  status: "idle",
  configurableData:[],
  daysDataPicker: "idle",
  isActiveGlobalCheckbox: "idle",
  quantityMainTableRequests: 1,
};
export const dataConfigurable = createAsyncThunk(
  '/configurable',
  async (data) => {
    const response = await getConfigurableData(data);
    if (!response) throw ({ message: response.data.message })
    return response;
  }
);

export const configurableSlice = createSlice({
  name: 'configurable',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(dataConfigurable.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(dataConfigurable.fulfilled, (state, action) => {
        state.status = 'fulfilled';
        state.configurableData = action.payload;
        state.daysDataPicker = action.payload[1].configurationValue;
        state.isActiveGlobalCheckbox = action.payload[2].configurationValue;
        state.quantityMainTableRequests = parseInt(action.payload[3].configurationValue);//20
      })
      .addCase(dataConfigurable.rejected, (state) => {
        state.status = 'rejected';
      })
  },
});

export const { reset } = configurableSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatus = (state) => state.configurable.status;
export const selectConfigurableData = (state) => state.configurable.configurableData;
export const selectDaysDataPicker = (state) => state.configurable.daysDataPicker;
export const selectIsActiveGlobalCheckbox = (state) => state.configurable.isActiveGlobalCheckbox;
export const selectQuantityMainTableRequests = (state) => state.configurable.quantityMainTableRequests;
export default configurableSlice.reducer;
